import { CustomSvgIconProps, SvgFilterByIconType } from './constants';

type BaseIconProps = CustomSvgIconProps & {
  src: string;
  alt: string;
};

export const BaseIcon = ({ width, height, variant, src, alt }: BaseIconProps) => (
  <img
    src={src}
    alt={alt}
    width={width}
    height={height}
    style={
      variant && SvgFilterByIconType[variant]
        ? { filter: SvgFilterByIconType[variant] }
        : {}
    }
  />
);
